import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { PLATFORMS } from "../../data/platforms";
import { HUBS } from "../../data/hubs";
import { GUIDES } from "../../data/guides";
import { DISCLOSURE_FTC, SITE } from "../../data/site";

const Footer = () => (
  <footer className="border-t border-white/5 bg-surface" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 py-16">
      <div className="grid gap-12 md:grid-cols-6">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-volt">
              <Mail className="h-4 w-4 text-ink" strokeWidth={2.5} />
            </span>
            <span className="font-display font-extrabold tracking-tight">Top Email<span className="text-volt">Tools</span></span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">{SITE.tagline}. Independent, hands-on reviews of email marketing software for small businesses, agencies, ecommerce, and nonprofits.</p>
          <Link to="/quiz" data-testid="footer-quiz" className="mt-5 inline-flex rounded-full border border-volt/40 px-5 py-2 text-xs font-bold text-volt transition-colors hover:bg-volt hover:text-ink">
            Take the 60-second platform quiz
          </Link>
        </div>
        <div>
          <p className="overline-label mb-4">Reviews</p>
          {PLATFORMS.map((p) => (
            <Link key={p.slug} to={`/reviews/${p.slug}`} data-testid={`footer-review-${p.slug}`} className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">{p.name}</Link>
          ))}
        </div>
        <div>
          <p className="overline-label mb-4">Best For</p>
          {HUBS.map((h) => (
            <Link key={h.slug} to={`/best/${h.slug}`} data-testid={`footer-hub-${h.slug}`} className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">{h.overline.replace("Best For · ", "")}</Link>
          ))}
        </div>
        <div>
          <p className="overline-label mb-4">Guides</p>
          {GUIDES.slice(0, 5).map((g) => (
            <Link key={g.slug} to={`/guides/${g.slug}`} data-testid={`footer-guide-${g.slug}`} className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">{g.title.split(":")[0]}</Link>
          ))}
          <Link to="/guides" data-testid="footer-guides-all" className="mb-2 block text-sm font-semibold text-volt/80 transition-colors hover:text-volt">All guides →</Link>
        </div>
        <div>
          <p className="overline-label mb-4">Company</p>
          <Link to="/about" data-testid="footer-about" className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">About</Link>
          <Link to="/resources" data-testid="footer-resources" className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">Resources</Link>
          <Link to="/affiliate-disclosure" data-testid="footer-disclosure" className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">Affiliate Disclosure</Link>
          <Link to="/privacy-policy" data-testid="footer-privacy" className="mb-2 block text-sm text-white/60 transition-colors hover:text-volt">Privacy Policy</Link>
        </div>
      </div>
      <p className="mt-12 border-t border-white/5 pt-8 text-xs leading-relaxed text-white/35">{DISCLOSURE_FTC}</p>
      <p className="mt-4 text-xs text-white/30">© 2026 {SITE.name}. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
